const resizeBannerPackageCouponService = (
  isMobile: boolean,
  size: number,
  type: 'width' | 'height'
) =>
  type === 'width'
    ? isMobile
      ? size > 512
        ? 512
        : size
      : size > 1240
        ? 1240
        : size
    : isMobile
      ? size > 256
        ? 256
        : size
      : size > 698
        ? 698
        : size;

export default resizeBannerPackageCouponService;
